// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"95d82586","238":"f6ac5d4b","453":"12a8c1c8","716":"05a0685d"}[chunkId] + ".chunk.js";
};